import React from 'react';
import { CompositeDecorator } from 'draft-js';
import {
  Link,
} from 'react-router-dom';

const LinkComponent = ({ entityKey, contentState, children }) => {
  const { url } = contentState.getEntity(entityKey).getData();
  if (url.indexOf('document:') !== -1) {
    return <Link to={`/documents/${url.split(':')[1]}`}>{children}</Link>;
  }

  return '';
};

const findLinkEntities = (contentBlock, callback, contentState) => contentBlock.findEntityRanges(
  character => {
    const entityKey = character.getEntity();

    return (
      entityKey !== null
      && contentState.getEntity(entityKey).getType() === 'LINK'
    );
  },
  callback,
);

const linkDecorator = new CompositeDecorator([
  {
    strategy: findLinkEntities,
    component: LinkComponent,
  },
]);

export default linkDecorator;
